import { Dispatch } from "react";
import confirmboxConstants from "./constants";

type PayloadType = {
  entity: string;
  operation: string;
  resources: Record<string, unknown> | Record<string, unknown>[];
};

type ConfirmBoxAction = {
  type: string;
  payload?: PayloadType;
};

export const confirmbox_open =
  ({ entity, operation, resources }: PayloadType) =>
  (dispatch: Dispatch<ConfirmBoxAction>) => {
    dispatch({
      type: confirmboxConstants.CONFIRMBOX_OPEN,
      payload: {
        entity,
        operation,
        resources,
      },
    });
  };

export const confirmbox_close =
  () => (dispatch: Dispatch<ConfirmBoxAction>) => {
    dispatch({ type: confirmboxConstants.CONFIRMBOX_CLOSE });
  };
